import React from 'react'
import PageNotFoundBanner from '../components/PageNotFoundBanner'

const PageNotFound = () => {
    return (
        <>
            <PageNotFoundBanner/>
        </>
    )
}

export default PageNotFound